import React, { useState } from "react";
import { TOK, SANS, PrimaryBtn, QuietLink, Title } from "./shared";
import { ExplainInput } from "./ExplainInput";

// Soulumo Coach's one follow-up question when the first Explain was too general.
export const ClarifyStep = ({ question, onAnswer, onSkip }) => {
  const [answer, setAnswer] = useState("");
  return (
    <div className="space-y-7" data-testid="simple-clarify-step">
      <div>
        <div className="text-[0.62rem] uppercase tracking-[0.3em]" style={{ color: TOK.goldSoft, fontFamily: SANS }}>Soulumo Coach</div>
        <div className="mt-2" data-testid="simple-clarify-question"><Title>{question}</Title></div>
      </div>
      <ExplainInput value={answer} onChange={setAnswer} placeholder="A sentence or two is perfect." testId="simple-clarify-input" />
      <PrimaryBtn testId="simple-clarify-continue" disabled={answer.trim().length < 3} onClick={() => onAnswer(answer)}>Continue</PrimaryBtn>
      <QuietLink testId="simple-clarify-skip" onClick={onSkip}>Skip — create from what I said</QuietLink>
    </div>
  );
};
